
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit} from "../../../comman/config";
import { can } from "../../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import { ItemNameStacked } from '../../../components/ItemName';
import Loader from "../../../components/Loader";
import { menuAboveTable } from "../../../comman/selectMenu";
// import Pagination from "react-js-pagination";



function List() {

    const [ItemList, setItemList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [categoryFilter, setCategoryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('1'); // '1' = Enable, '0' = Disable, 'all' = All
    const [methodList, setMethodList] = useState([]);
    // Multi-select: an item carries several methods, so the filter matches an item that has ANY of
    // the picked ones rather than all of them.
    const [methodFilter, setMethodFilter] = useState([]);

    // role 0 = superadmin, 1 = admin. Both may enable and disable; only the superadmin may delete.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');

    const navigate = useNavigate();

    useEffect(() => {
        getItems();
        getCategories();
        getMethods();
    }, []);

    useEffect(() => {
        let filterelist = ItemList;

        if (statusFilter !== 'all') {
            filterelist = filterelist.filter(item => String(item.status) === statusFilter);
        }

        if (categoryFilter !== '') {
            filterelist = filterelist.filter(item => String(item.category?.id ?? '') === categoryFilter);
        }

        if (methodFilter.length > 0) {
            const picked = new Set(methodFilter.map((m) => String(m.value)));
            filterelist = filterelist.filter(item =>
                (item.method || []).some((m) => picked.has(String(m.id)))
            );
        }

        if (searchQuery) {
            const q = searchQuery.toLowerCase();
            filterelist = filterelist.filter(item =>
                (item.eng_name || '').toLowerCase().includes(q) ||
                (item.item_name || '').toLowerCase().includes(q)
            );
        }

        setFilteredList(filterelist);
    }, [searchQuery, categoryFilter, statusFilter, methodFilter, ItemList]);
    const getItems = async () => {
        // try/finally: the spinner this sets is drawn now, and a request that fails -- the case a
        // spinner exists for -- must not leave it turning over an empty table for good.
        setPopupOpen(true);
        try {
            const response = await axios.get(`${baseUrl}/item/list?page=${page}&limit=${limit}`);
            setItemList(response.data.data);
            setFilteredList(response.data.data);
            setTotalItem(response.data.totalItem);
        } catch (error) {
            console.log(error);
            alert('Could not load the list. Check the connection and try again.');
        } finally {
            setPopupOpen(false);
        }
    }

    const getCategories = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_category_master&condition=status=1`);
        setCategoryList(response.data.data || []);
    }

    const getMethods = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=method_master&condition=status=1`);
        setMethodList(response.data.data || []);
    }

    const handelFilterChange= (e) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    // Clear returns the screen to how it opens -- empty search, no category, no method, Enable
    // only -- rather than to "everything", which is what the All status option is for.
    const handleClear = () => {
        setSearchQuery('');
        setCategoryFilter('');
        setStatusFilter('1');
        setMethodFilter([]);
    };

    const deleteMenuitem = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this item?");
        if (shouldDelete) {
            try {
                await axios.delete(`${baseUrl}/item/delete/${id}`, { data: { role } });
                window.location.reload();
            } catch (error) {
                alert(error?.response?.data?.msg ?? 'Could not disable the item.');
            }
        }
    };

    // Delete removes the row, unlike Disable which is recoverable, so its confirmation says so
    // rather than reusing the Disable wording. Whether the item is still on a menu is the
    // backend's call -- it counts the meal_master rows and refuses with the reason, which is what
    // gets shown here. Checking in the browser would be a second, staler answer.
    const destroyMenuitem = async (id) => {
        if (!window.confirm("Permanently DELETE this item? Disable is reversible; this is not.")) return;
        try {
            await axios.delete(`${baseUrl}/item/destroy/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the item.');
        }
    };

    const enableMenuItem = async (id) => {
        const shouldEnable = window.confirm("Are you sure you want to enable this item?");
        if (shouldEnable) {
            try {
                const response = await axios.post(`${baseUrl}/item/enable/${id}`, { role });
                console.log(response.data)
                if(response.data.status === true){
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const editMenuitem = async (id) => {
        navigate(`/item/edit/${btoa(id)}`, { state: ItemList.filter(item => item.id == id) });
    }

    // The maharaj whose recipe stands for the item. "Auto" -- not "-" -- when no recipe is
    // marked default, because that is the setting's own name on the Add/Edit screen and it means
    // something: the menu screens pick the maharaj themselves rather than nothing being set.
    const defaultRecipeLabel = (item) => item.default_recipe?.maharaj_name || "Auto";

    const handleExport = () => {
        const header = ["Item name", "Category", "Default Recipe", "Method"];
        const data =   filteredList.map((item) => {
            let resultArray = [];
            resultArray.push(`${item.item_name} (${item.eng_name})`);
            resultArray.push(`${item.category ? `${item.category.name} (${item.category.eng_name})` : "-"}`)
            resultArray.push(defaultRecipeLabel(item))
            resultArray.push(`${(item.method || []).map((m) => m.name).join(' / ') || "-"}`)
            return resultArray;
        })
        
        
        const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Item List");

        XLSX.writeFile(workbook, `Item_list.xlsx`);
    }

   


    return (
        <div className="p-4">
            {popupOpen && <Loader />}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-2xl font-bold">Item Master</h1>
                <div>
                    <button onClick={handleExport} className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Export</button>
                    <Link to="/item/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Item</button>
                    </Link>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <div className="pb-4 flex flex-column sm:flex-row flex-wrap gap-3 space-y-4 sm:space-y-0 items-center justify-between">
                    <label htmlFor="table-search" className="sr-only">Search</label>
                    <div className="flex flex-wrap gap-3 items-center">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                                <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                            </div>
                            <input type="text" value={searchQuery} onChange={handelFilterChange} id="table-search" className="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
                        </div>
                        <select
                            value={categoryFilter}
                            onChange={(e) => setCategoryFilter(e.target.value)}
                            className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">All Categories</option>
                            {categoryList.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                    {cat.name}{cat.eng_name ? ` (${cat.eng_name})` : ''}
                                </option>
                            ))}
                        </select>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="1">Enable</option>
                            <option value="0">Disable</option>
                            <option value="all">All</option>
                        </select>
                        <div className="w-64">
                            <Select
                                {...menuAboveTable}
                                isMulti
                                classNamePrefix="select"
                                value={methodFilter}
                                onChange={(selected) => setMethodFilter(selected ?? [])}
                                options={methodList.map((m) => ({ value: m.id, label: m.name }))}
                                placeholder="All Methods"
                            />
                        </div>
                        <button
                            onClick={handleClear}
                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                        >
                            Clear
                        </button>
                    </div>
                </div>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Item name</th>
                            <th scope="col" className="px-6 py-3">Category</th>
                            <th scope="col" className="px-6 py-3">Default Recipe</th>
                            <th scope="col" className="px-6 py-3">Method</th>
                            <th scope="col" className="px-6 py-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {filteredList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"><ItemNameStacked item={item} /></th>
                            <td className="px-6 py-4">{item.category ? `${item.category.name} (${item.category.eng_name})` : "-"}</td>
                            <td className="px-6 py-4">{defaultRecipeLabel(item)}</td>
                            <td className="px-6 py-4">{(item.method || []).map((m) => m.name).join(' / ') || "-"}</td>
                            <td className="px-6 py-4">
                            <div className="flex gap-2">
                                {item.status == 1 && <button
                                    type="button"
                                    onClick={() => editMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                    Edit
                                </button>}
                                {item.status == 1 && canDisable && <button
                                    type="button"
                                    onClick={() => deleteMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                    Disable
                                </button>}
                                {item.status == 0 && canActivate && <button
                                    type="button"
                                    onClick={() => enableMenuItem(item.id)}
                                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                    Enable
                                </button>}
                                {canDelete && <button
                                    type="button"
                                    onClick={() => destroyMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                    Delete
                                </button>}
                            </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;